import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2 } from 'lucide-react';
export function FinalCTASection() {
  const checkoutUrl = 'https://pay.hotmart.com/F104765975P?checkoutMode=10';
  return <section className="py-16 md:py-24 px-4 bg-forest text-white relative" data-id="element-30">
      <div className="max-w-3xl mx-auto text-center" data-id="element-31">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-gold mb-8" data-id="element-32">
          Es Tu Momento
        </h2>

        <div className="space-y-4 text-lg md:text-xl text-cream/90 mb-12" data-id="element-33">
          <p data-id="element-34">
            Durante demasiado tiempo has buscado la solución en lo que comes al
            mediodía.
          </p>
          <p className="font-bold text-white" data-id="element-35">
            La solución siempre estuvo en lo que comes de noche.
          </p>
          <p data-id="element-36">
            Tienes el método ahora mismo. A $6.39 USD. Con garantía total de 30
            días.
          </p>
          <p className="italic text-gold" data-id="element-37">
            No hay razón para esperar una semana más. Una noche más. Un espejo
            más.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-10 shadow-2xl text-dark max-w-xl mx-auto" data-id="element-38">
          <div className="mb-6" data-id="element-39">
            <p className="text-sm font-bold text-urgency uppercase tracking-wider mb-2" data-id="element-40">
              Precio de Lanzamiento
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-41">
              <span className="text-2xl text-dark/40 line-through font-bold" data-id="element-42">
                $29.00
              </span>
              <span className="text-5xl font-serif font-bold text-forest" data-id="element-43">
                $6.39 <span className="text-xl" data-id="element-44">USD</span>
              </span>
            </div>
          </div>

          <CTAButton text="OBTENER MI PROTOCOLO AHORA" href={checkoutUrl} variant="primary" className="text-xl py-4 mb-6" data-id="element-45" />

          <div className="text-sm text-dark/70 space-y-2 text-left bg-cream p-4 rounded-xl" data-id="element-46">
            <p className="font-bold text-center mb-2 text-forest" data-id="element-47">
              ¿Aún tienes dudas? Recuerda:
            </p>
            <div className="grid grid-cols-1 gap-2" data-id="element-48">
              <p className="flex items-center gap-2" data-id="element-49">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-50" />{' '}
                Garantía completa de 30 días
              </p>
              <p className="flex items-center gap-2" data-id="element-51">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-52" />{' '}
                Acceso inmediato tras la compra
              </p>
              <p className="flex items-center gap-2" data-id="element-53">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-54" /> 15
                minutos por noche es todo lo que necesitas
              </p>
              <p className="flex items-center gap-2" data-id="element-55">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-56" />{' '}
                Diseñado para mujeres de más de 35 años
              </p>
            </div>
          </div>

          <p className="text-xs text-dark/50 mt-6 italic" data-id="element-57">
            Al completar tu compra recibirás acceso inmediato a todos los
            materiales en formato digital PDF. Compatible con todos los
            dispositivos.
          </p>
        </div>

        <div className="mt-12 text-cream/80 text-lg" data-id="element-58">
          <p className="font-bold text-white mb-2" data-id="element-59">
            La única decisión equivocada es no tomar ninguna.
          </p>
          <p data-id="element-60">Tu cuerpo lleva tiempo pidiéndote esto.</p>
          <p data-id="element-61">Esta noche puedes empezar a escucharlo.</p>
        </div>
      </div>
    </section>;
}